import api from "@/lib/api";
import { toast } from "sonner";

export const VISIBILITY_OPTIONS = [
  { value: "private", label: "Private", hint: "Only you" },
  { value: "firm", label: "Firm Only", hint: "Your whole firm" },
  { value: "client", label: "Shared with Client", hint: "Visible in client portal" },
];

export function visibilityLabel(v) {
  return VISIBILITY_OPTIONS.find((o) => o.value === v)?.label || v;
}

export function visibilityClass(v) {
  const map = {
    private: "bg-slate-100 text-slate-600 border-slate-200",
    firm: "bg-blue-50 text-blue-700 border-blue-200",
    client: "bg-emerald-50 text-emerald-700 border-emerald-200",
  };
  return map[v] || map.private;
}

export function humanSize(bytes) {
  if (!bytes && bytes !== 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function isImage(contentType = "") {
  return contentType.startsWith("image/");
}

async function fetchBlob(doc) {
  const res = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function downloadDocument(doc) {
  try {
    const url = await fetchBlob(doc);
    const a = document.createElement("a");
    a.href = url;
    a.download = doc.original_filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  } catch {
    toast.error("Unable to download the document. Please try again.");
  }
}

export async function previewDocument(doc) {
  try {
    const url = await fetchBlob(doc);
    window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    toast.error("Unable to open the document. Please try again.");
  }
}
